import { useState } from "react";
import { Modal } from "@mantine/core";
import { withTranslation } from "react-i18next";
import InputField from "../../../components/inputField";
import Button from "../../../components/Button";
import { backendUrl } from "../../../constants";

const NewLocation = ({ opened, setOpened, setRefetch }) => {
  let createdBy = JSON.parse(localStorage.getItem("userData"));
  const [locationData, setLocationData] = useState({createdBy: createdBy.id});

  const handleAddLocation = () => {
    const options = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-type": "application/json",
      },
      body: JSON.stringify(locationData),
    };
    fetch(`${backendUrl}empLocation/addEmpLocation`, options)
      .then((response) => response.json())
      .then((response) => {
        setOpened(false);
        setRefetch(true);
      })
      .catch((err) => console.error(err));
  };

  return (
    <>
      <Modal
        opened={opened}
        centered
        onClose={() => setOpened(false)}
        title="Add New Location"
      >
        <div className="new-location">
          <InputField
            placeholder="Location Name"
            style={{ border: "1px solid rgb(0,0,0,0.1)" }}
            onChange={(v) =>
              setLocationData((locationData) => ({
                ...locationData,
                locationName: v.target.value,
              }))
            }
          />
          <InputField
            placeholder="Address"
            style={{ border: "1px solid rgb(0,0,0,0.1)" }}
            onChange={(v) =>
              setLocationData((locationData) => ({
                ...locationData,
                address: v.target.value,
              }))
            }
          />
          <InputField
            placeholder="City"
            style={{ border: "1px solid rgb(0,0,0,0.1)" }}
            onChange={(v) =>
              setLocationData((locationData) => ({
                ...locationData,
                city: v.target.value,
              }))
            }
          />
          <InputField
            placeholder="State"
            style={{ border: "1px solid rgb(0,0,0,0.1)" }}
            onChange={(v) =>
              setLocationData((locationData) => ({
                ...locationData,
                state: v.target.value,
              }))
            }
          />
          <InputField
            placeholder="Zip"
            style={{ border: "1px solid rgb(0,0,0,0.1)" }}
            onChange={(v) =>
              setLocationData((locationData) => ({
                ...locationData,
                zipCode: v.target.value,
              }))
            }
          />
          <div className="d-flex justify-content-end gap-2">
            <Button title="Cancel" onClick={() => setOpened(false)} />
            <Button
              title="Add Location"
              primary={true}
              onClick={handleAddLocation}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};
export default withTranslation()(NewLocation);
